import { Controller } from "@hotwired/stimulus"
import { showToast } from "../lib/platform_toast"
import { NativeBridge } from "../lib/native_bridge"

const HAPTIC_BY_VARIANT = { error: "error", warning: "warning" }

// Forwards a server flash message to the platform toast (native on iOS).
export default class extends Controller {
  static values = { message: String, variant: { type: String, default: "success" }, haptic: Boolean }

  connect() {
    if (this.messageValue) showToast(this.messageValue, this.variantValue)
    if (this.messageValue && this.hapticValue) NativeBridge.Haptic.notification(HAPTIC_BY_VARIANT[this.variantValue] || "success")
    this.element.remove()
  }
}
